import React, { useEffect, useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, notification, Row } from "antd";
import IMAGES from "../../const/Image";
import ReCAPTCHA from "react-google-recaptcha";
import { ForgotPassword } from "../../const/ForgotPassword/ForgotPassword";
import { useNavigate } from "react-router-dom";
import {
  createService,
  generateSessionToken,
} from "../../Services/AppoinmentServices";
import uuid from "react-uuid";
import { login } from "../../Services/AuthServices";
import { generateDeviceToken } from "../../firebase";

export const Login = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logintoken, setLoginToken] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  async function getCsrfToken() {
    try {
      const uuidvar = uuid();
      const res = await createService(uuidvar);
      const CsrfToken = res?.data?.csrfToken;
      const resf = await generateSessionToken(CsrfToken);
      setLoginToken(resf.data.sessionToken);
    } catch (e) {
      console.log(e, "Error fetching CSRF token");
    }
  }

  useEffect(() => {
    getCsrfToken();
  }, []);

  const onCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const onFinish = async (values) => {
    if (!captchaValue) {
      notification.error({
        message: "Error",
        description: "Please complete the captcha verification!",
      });
      return;
    }

    setLoading(true);
    try {
      // Login does not depend on FCM — FCM is requested after login
      const deviceToken = generateDeviceToken();

      const payload = {
        loginId: values.loginId,
        password: values.password,
        deviceToken,
        fcmToken: "",
      };

      const res = await login(payload, logintoken);

      if (res.status === 200) {
        localStorage.setItem("device_token", deviceToken);
        // Ask Layout to show notification permission popup after login
        localStorage.setItem("prompt_notification_permission", "1");

        localStorage.setItem("accesstoken", res?.data?.data?.accessToken);
        localStorage.setItem("login", res?.data?.data?.profile?.name);
        localStorage.setItem(
          "userProfile",
          JSON.stringify(res?.data?.data?.profile)
        );

        notification.success({
          message: "Success",
          description: res?.data?.message || "Login successful!",
        });

        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Login Error:", error);
      notification.error({
        message: "Login Failed",
        description:
          error?.response?.data?.message ||
          "Login failed. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login-my-beauty">
        <div className="welcome-cont">
          <div className="first-login-img text-center"></div>
        </div>
        <div className="Login-Page">
          <div className="Login-Form">
            <Form
              name="login"
              initialValues={{
                remember: true,
              }}
              style={{
                backgroundColor: "#fff",
                padding: "50px",
                borderRadius: "20px",
              }}
              onFinish={onFinish}
            >
              <Row className="LogIn-BMB-Logo"></Row>
              <Row className="LogIn-BMB-Logo">
                <img className="BMBLogo" src={IMAGES.BMBSimpleLogo} alt="" />
              </Row>

              <Form.Item
                label="Email"
                name="loginId"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your Email!",
                  },
                  {
                    type: "email",
                    message: "This is not valid E-mail!",
                  },
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined />}
                  placeholder="Email"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your Password!",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <ReCAPTCHA
                  sitekey="6LeBR2stAAAAAD5QEaqonBBvjWqI956FEARIlNqS"
                  onChange={onCaptchaChange}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  block
                  size="large"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>

      <ForgotPassword isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </>
  );
};
